<!-- service search -->
<div class="bg-grey-card">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="title-xxlarge mb-4 mt-5 mb-lg-10">
          Esplora tutti i servizi
        </h2>
      </div>

      <div class="col-12 col-lg-8 pt-lg-50 pb-lg-50">
        <div class="cmp-input-search">
          <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
            <div class="input-group">
              <label
                for="autocomplete-autocomplete-three"
                class="visually-hidden"
                >Cerca una parola chiave</label
              >
              <input
                #searchInput
                (keyup.enter)="search(searchInput.value, true)"
                type="search"
                class="autocomplete form-control"
                placeholder="Cerca una parola chiave"
                id="autocomplete-autocomplete-three"
                name="autocomplete-three"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  type="button"
                  id="button-3"
                  (click)="search(searchInput.value, true)"
                >
                  Invio
                </button>
              </div>

              <span class="autocomplete-icon" aria-hidden="true">
                <svg class="icon icon-sm icon-primary">
                  <use
                    href="/bootstrap-italia/dist/svg/sprites.svg#it-search"
                  ></use>
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center"
          *ngIf="searchServiceService.isLoading()"
        >
          <div class="progress-spinner progress-spinner-active spinner-lg">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <ng-container
          *ngIf="
            !this.searchServiceService.alreadySearched;
            else showSearchResults
          "
        >
          <ng-container *ngIf="allServices().length; else noResult">
            <p class="mb-4">
              <strong> {{totalServices}} </strong> servizi trovati in ordine alfabetico
            </p>

            <app-card
              *ngFor="let item of allServices()"
              [title]="item.title"
              [description]="item.shortDescription ? stringSubstr(item.shortDescription, 0, 255) : ''"
              [tipologia]="item?.category"
              [link]="item?.path"
              dataElement="service-link"
            ></app-card>

            <button
              *ngIf="!searchServiceService.noMoreResults"
              (click)="searchServiceService.getAllServices()"
              type="button"
              data-element="load-other-cards"
              class="btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mt-3 mb-lg-50 full-mb text-button"
            >
              <span class="">Carica altri risultati</span>
            </button>
          </ng-container>

          <ng-template #noResult>
            <span
              *ngIf="!searchServiceService.isLoading()"
              class="mb-5 d-flex justify-content-center"
              >Nessun risultato trovato.</span
            >
          </ng-template>
        </ng-container>

        <ng-template #showSearchResults>
          <ng-container *ngIf="this.searchResults().length; else noResult">
            <p class="mb-4">
              <strong>{{ searchResults().length }} </strong>servizi trovati
            </p>
            <app-card
              *ngFor="let item of searchResults()"
              [title]="item.title"
              [description]="item.shortDescription"
              [tipologia]="item?.category"
              [link]="item?.path"
              dataElement="service-link"
            ></app-card>

            <button
              *ngIf="!searchServiceService.noMoreResults"
              (click)="search(searchInput.value)"
              type="button"
              data-element="load-other-cards"
              class="btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mt-3 mb-lg-50 full-mb text-button"
            >
              <span class="">Carica altri risultati</span>
            </button>
          </ng-container>
          <ng-template #noResult>
            <span
              *ngIf="!searchServiceService.isLoading()"
              class="d-flex mb-5 justify-content-center"
              >Nessun risultato trovato.</span
            >
          </ng-template>
        </ng-template>
      </div>

      <div
        class="col-12 col-lg-4 pt-30 pt-lg-5 ps-lg-5 order-first order-md-last pb-lg-5"
      >
        <div class="link-list-wrap">
          <h2 class="title-xsmall-semi-bold">
            <span>SERVIZI IN EVIDENZA</span>
          </h2>
          <ul
            class="link-list t-primary"
            *ngIf="inEvidenza.length; else noEvidenza"
          >
            <li class="mb-3 mt-3" *ngFor="let itemEvidenza of inEvidenza">
              <a class="list-item ps-0 title-medium" [href]="itemEvidenza.path">
                <span>{{ itemEvidenza.title }}</span>
              </a>
            </li>
          </ul>
          <ng-template #noEvidenza>Nessun servizio in evidenza</ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cards category list -->
<div class="container py-5">
  <h2 class="title-xxlarge mb-4">Esplora per categoria</h2>
  <div class="row g-4" *ngIf="categories.length; else noCategories">
    <div class="col-md-6 col-xl-4" *ngFor="let category of categories">
      <div
        class="cmp-card-simple card-wrapper pb-0 rounded border border-light"
      >
        <div class="card shadow-sm rounded">
          <div class="card-body">
            <a
              [routerLink]="[category.path]"
              class="text-decoration-none"
              data-element="service-category-link"
            >
              <h3 class="card-title t-primary title-xlarge">
                {{ category.title }}
              </h3>
            </a>
            <p class="text-secondary mb-0">
              {{ category.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noCategories>Nessuna categoria da visualizzare</ng-template>
</div>
